module.exports = __webpack_public_path__ + "static/13-Breast cancer pink ribbon-599fc24bd217129e10e7e3f91b14a150.jpg";